import { throttle } from 'lodash-es';
import { useEffect, useMemo, useState } from 'react';

export const useThrottledState = <T>(
  initialValue: T,
  wait = 300
): [T, (T) => void] => {
  const [input, setInput] = useState<T>(initialValue);
  const [state, setState] = useState<T>(initialValue);

  const throttleUpdateSearchQuery = useMemo(
    () => throttle(setState, wait, { leading: false }),
    [setState]
  );

  useEffect(() => {
    throttleUpdateSearchQuery(input);
  }, [input, throttleUpdateSearchQuery]);

  return [state, setInput];
};
